// removed by extract-text-webpack-plugin
module.exports = {"content":"_360MLHqCtE95xt4v-Ve9vs"};


//////////////////
// WEBPACK FOOTER
// ./elements/HtmlContent.scss
// module id = 502
// module chunks = 0